import { render, staticRenderFns } from "./StudentApplicationDetailList.vue?vue&type=template&id=edcc9e0c&"
import script from "./StudentApplicationDetailList.vue?vue&type=script&lang=ts&"
export * from "./StudentApplicationDetailList.vue?vue&type=script&lang=ts&"
import style0 from "./StudentApplicationDetailList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports